import * as braze from '@braze/web-sdk';
import { getBrazeId, getMaTracking } from '~/utils/utils';

export default defineNuxtPlugin((nuxt) => {
  nuxt.hook('app:beforeMount', () => {
    const runtimeConfig = useRuntimeConfig().public;
    const brazeConfig = getBrazeConfig();

    if (!brazeConfig || !brazeConfig.apiKey) {
      console.log('Braze is not configured');
      return;
    }

    const storageKey = runtimeConfig.subscribedDataLocalStorageKey;
    const brazeId = getBrazeId(storageKey);
    const deviceId = localStorage.getItem('brazeDeviceId') || undefined;

    const initOptions = {
      baseUrl: brazeConfig.baseUrl,
      enableSdkAuthentication: deviceId ? false : undefined,
      nocookies: deviceId ? false : undefined,
      allowUserSuppliedJavascript: true,
      deviceId
    };

    braze.initialize(brazeConfig.apiKey, initOptions);
    if (!deviceId) {
      braze.automaticallyShowInAppMessages();
    }

    const bannerConfig = brazeConfig.bannerConfig;
    const brazeBannerCard = useBrazeBannerCard(braze, bannerConfig);
    brazeBannerCard.subscribeToBannersUpdates();

    const openSessionUsingThreshold = () => {
      const existingStartTime = sessionStorage.getItem('anonymousSessionStart');
      if (!existingStartTime) {
        sessionStorage.setItem('anonymousSessionStart', Date.now().toString());
      }

      const activationTime = brazeConfig?.options?.threshold || 200;
      const startTime = parseInt(sessionStorage.getItem('anonymousSessionStart') || '0');
      const activeTime = (Date.now() - startTime) / 1000;

      if (activeTime >= activationTime) {
        console.log(`User has been active for ${activationTime}+ seconds, opening Braze session`);
        braze.openSession();
        sessionStorage.removeItem('anonymousSessionStart');
      } else {
        const remainingTime = (activationTime - activeTime) * 1000;
        console.log(`Setting timeout for ${remainingTime}ms to open Braze session`);
        const timeoutId = setTimeout(() => {
          if (!brazeId) {
            console.log(`User has been active for ${activationTime}+ seconds, opening Braze session`);
            braze.openSession();
          }
          sessionStorage.removeItem('anonymousSessionStart');
          clearTimeout(timeoutId);
        }, remainingTime);
      }
    };

    if (brazeId) {
      braze.changeUser(brazeId);
      brazeBannerCard.requestBannersRefresh();
      braze.openSession();
    } else {
      console.log('Anonymous user');
      brazeBannerCard.requestBannersRefresh();
      if (brazeConfig?.options?.threshold) {
        openSessionUsingThreshold();
      } else {
        const maTracking = getMaTracking();
        if (maTracking?.ma) {
          if (!maTracking.expiry || Date.now() > maTracking.expiry) {
            localStorage.removeItem('ma_tracking');
            return;
          }
          console.log('Opening Braze session for anonymous user');
          braze.openSession();
        }
        useEventListener(document, 'visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            const maTracking = getMaTracking();
            if (maTracking?.ma) {
              if (!maTracking.expiry || Date.now() > maTracking.expiry) {
                localStorage.removeItem('ma_tracking');
                return;
              }
              console.log('Opening Braze session for anonymous user');
              braze.openSession();
            }
          }
        });
      }
    }
    nuxt.provide('braze', braze);
  });
});
